import Back from '../../../../features/back/Back';
import classNames from 'classnames';
import combineModifiers from '../../../../../utils/modifiers/combineModifiers';

export default function Header({ className, modifier, back }) {
  return (
    <div
      className={classNames(
        'universal-modal__header',
        className,
        ...combineModifiers('universal-modal__header', modifier),
      )}
    >
      {back && <Back {...back} />}
    </div>
  );
}
